import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import Modal from "../../../Basic/Modal";
import CommonLoad from "../../../Basic/Spin";
import Notification from "../../../Basic/Notification";
import { deletePlantApi } from "../../api";

var DeleteModal = /*#__PURE__*/function (_Component) {
  _inherits(DeleteModal, _Component);

  var _super = _createSuper(DeleteModal);

  function DeleteModal() {
    var _this;

    _classCallCheck(this, DeleteModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOk", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                loading: true
              });

              _context.prev = 1;
              _context.next = 4;
              return deletePlantApi(_this.props.selectedPlant.ObjectID);

            case 4:
              _this.setState({
                loading: false
              });

              _this.props.toggle();

              _this.props.refreshCallback();

              Notification.open({
                description: _this.props.translate('SFxAccountSettingsDeletePlantSuccessMessage')
              });
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);

              _this.setState({
                loading: false
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    })));

    return _this;
  }

  _createClass(DeleteModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          toggle = _this$props.toggle,
          prefix = _this$props.prefix,
          selectedPlant = _this$props.selectedPlant,
          translate = _this$props.translate;
      var loading = this.state.loading;
      return /*#__PURE__*/React.createElement(React.Fragment, null, loading && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-mask")
      }, /*#__PURE__*/React.createElement(CommonLoad, {
        size: 0.2
      })), /*#__PURE__*/React.createElement(Modal, {
        centered: true,
        backdrop: "static",
        title: translate('SFxAccountSettingsDeletePlantModalTitle'),
        isOpen: isOpen,
        toggle: toggle,
        cancelText: translate('SFxAccountSettingsCancelButtonText'),
        okText: translate('SFxAccountSettingsDeleteButtonText'),
        onCancel: toggle,
        onOk: this.handleOnOk
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-delete-modal")
      }, /*#__PURE__*/React.createElement("p", null, selectedPlant.Name && translate('SFxAccountSettingsConfirmDeletePlantMessage', selectedPlant.Name)))));
    }
  }]);

  return DeleteModal;
}(Component);

export default DeleteModal;